// Test code changed on 28th Aug. If not working un comment code at line 1
// import {
//   Avatar,
//   Badge,
//   Box,
//   Button,
//   Divider,
//   Drawer,
//   IconButton,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import "./Navbar.css";
// import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
// import StorefrontIcon from "@mui/icons-material/Storefront";
// import SearchIcon from "@mui/icons-material/Search";
// import MenuIcon from "@mui/icons-material/Menu";
// import { mainCategory } from "../../../data/category/mainCategory";
// import CategorySheet from "./CategorySheet";
// import DrawerList from "./DrawerList";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { fetchUserProfile } from "../../../Redux Toolkit/Customer/UserSlice";
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import { FavoriteBorder } from "@mui/icons-material";


// const Navbar = () => {
//   const [showSheet, setShowSheet] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState("men");
//   const theme = useTheme();
//   const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
//   const dispatch = useAppDispatch();
//   const { user, auth, cart, sellers } = useAppSelector((store) => store);
//   const navigate = useNavigate();


//   const [open, setOpen] = React.useState(false);

//   const toggleDrawer = (newOpen: boolean) => () => {
//     setOpen(newOpen);
//   };



//   const becomeSellerClick = () => {
//     if (sellers.profile?.id) {
//       navigate("/seller")
//     } else navigate("/become-seller")
//   }



//   return (
//     <Box
//       sx={{ zIndex: 2 }}
//       className="sticky top-0 left-0 right-0 bg-white blur-bg bg-opacity-80 "
//     >
//       <div className="flex items-center justify-between px-4 md:px-6 lg:px-20 h-14 md:h-[70px] border-b">

//         <div className="flex items-center gap-4 md:gap-9">

//           <div className="flex items-center gap-2">
//             {!isLarge && (
//               <IconButton onClick={() => toggleDrawer(true)()}>
//                 <MenuIcon className="text-gray-700" sx={{ fontSize: { xs: 22, sm: 24, md: 27, lg: 29 } }} />

//               </IconButton>
//             )}
//             <h1
//               onClick={() => navigate("/")}
//               // className="logo items-center gap-2 cursor-pointer text-lg md:text-2xl  text-[#00927c]"

//               className="logo flex items-center gap-2 cursor-pointer text-lg md:text-2xl  text-[#00927c]"
//             >
//               <img
//                 src="/logo.png"
//                 alt="Priya Beads Logo"
//                 className="h-6 md:h-20 w-auto"
//               />
//               Priya Beads
//             </h1>
//           </div>

//           {isLarge && (
//             <ul
//               className="flex it
//           ems-center font-medium text-gray-800 "
//             >
//               {mainCategory.map((item) => (
//                 <li
//                   onMouseLeave={() => {
//                     // setSelectedCategory("")
//                     setShowSheet(false);
//                   }}
//                   onMouseEnter={() => {
//                     setSelectedCategory(item.categoryId);
//                     setShowSheet(true);
//                   }}
//                   className="mainCategory hover:text-[#00927c] cursor-pointer hover:border-b-2 h-[70px] px-4 border-[#00927c] flex items-center"
//                 >
//                   {item.name}
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>

//         <div className="flex items-center gap-2 sm:gap-3 md:gap-4 lg:gap-6">
//           <IconButton onClick={() => navigate("/search-products")}>
//             <SearchIcon className="text-gray-700" sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }} />
//           </IconButton>

//           {user.user ? (
//             <Button
//               onClick={() => navigate("/account/orders")}
//               className="flex items-center gap-2"
//             >
//               <Avatar sx={{ width: { xs: 22, sm: 23, md: 24, lg: 25 }, height: { xs: 22, sm: 23, md: 24, lg: 25 } }}

//                 src="https://cdn.pixabay.com/photo/2015/04/15/09/28/head-723540_640.jpg"
//               // src="https://www.tanishq.co.in/dw/image/v2/BKCK_PRD/on/demandware.static/-/Library-Sites-TanishqSharedLibrary/default/dwc0abe627/homepage/ShopByGender/Woman.jpg"
//               />
//               <h1 className="font-semibold hidden lg:block">
//                 {user.user?.fullName?.split(" ")[0]}
//               </h1>
//             </Button>
//           ) : (
//             <Button
//               variant="contained"
//               startIcon={<AccountCircleIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />}
//               sx={{ px: { xs: 1.25, sm: 1.5, md: 2 }, py: { xs: 0.5, sm: 0.75 }, fontSize: { xs: 12, sm: 13, md: 14 } }}
//               onClick={() => navigate("/login")}
//             >
//               Login
//             </Button>


//           )}

//           <IconButton onClick={() => navigate("/wishlist")}>
//             <FavoriteBorder sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }} className="text-gray-700" />
//           </IconButton>

//           <IconButton onClick={() => navigate("/cart")}>
//             <Badge
//               badgeContent={cart.cart?.cartItems.length}
//               color="primary"
//               sx={{
//                 '& .MuiBadge-badge': {
//                   fontSize: { xs: 10, md: 11, lg: 12 },
//                   minWidth: { xs: 16, md: 18, lg: 20 },
//                   height: { xs: 16, md: 18, lg: 20 }
//                 }
//               }}
//             >
//               <AddShoppingCartIcon
//                 sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }}
//                 className="text-gray-700"
//               />
//             </Badge>

//           </IconButton>
//         </div>
//       </div>
//       <Drawer open={open} onClose={toggleDrawer(false)}>
//         {<DrawerList toggleDrawer={toggleDrawer} />}
//       </Drawer>
//       {showSheet && selectedCategory && (
//         <div
//           onMouseLeave={() => setShowSheet(false)}
//           onMouseEnter={() => setShowSheet(true)}
//           className="categorySheet absolute top-[4.41rem] left-20 right-20 "
//         >
//           <CategorySheet
//             setShowSheet={setShowSheet}
//             selectedCategory={selectedCategory}
//           />
//         </div>
//       )}
//     </Box>
//   );
// };

// export default Navbar;


import {
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Navbar.css";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import StorefrontIcon from "@mui/icons-material/Storefront";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import { mainCategory } from "../../../data/category/mainCategory";
import CategorySheet from "./CategorySheet";
import DrawerList from "./DrawerList";
import { useNavigate, useSearchParams } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { fetchUserProfile } from "../../../Redux Toolkit/Customer/UserSlice";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { FavoriteBorder } from "@mui/icons-material";

const Navbar = () => {
  const [showSheet, setShowSheet] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("men");
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const dispatch = useAppDispatch();
  const { user, auth, cart, sellers } = useAppSelector((store) => store);
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const becomeSellerClick = () => {
    if (sellers.profile?.id) {
      navigate("/seller");
    } else navigate("/become-seller");
  };

  return (
    <Box
      sx={{ zIndex: 1400 }}
      className="sticky top-0 left-0 right-0 relative bg-white"
    >
      <div className="flex items-center justify-between px-4 md:px-6 lg:px-20 h-14 md:h-[70px] border-b bg-white">
        <div className="flex items-center gap-4 md:gap-9">
          <div className="flex items-center gap-2">
            {!isLarge && (
              <IconButton onClick={() => toggleDrawer(true)()}>
                <MenuIcon
                  className="text-gray-700"
                  sx={{ fontSize: { xs: 22, sm: 24, md: 27, lg: 29 } }}
                />
              </IconButton>
            )}

            <h1
              onClick={() => navigate("/")}
              className="logo flex items-center gap-2 cursor-pointer text-lg md:text-2xl text-[#00927c]"
            >
              <img
                src="/logo.png"
                alt="Priya Beads Logo"
                // className="h-6 md:h-20 w-auto"
                className="h-10 sm:h-12 md:h-20 w-auto"
              />
              Priya Beads
            </h1>
          </div>

          {isLarge && (
            <ul className="flex items-center font-medium text-gray-800">
              {mainCategory.map((item) => (
                <li
                  key={item.categoryId}
                  onMouseLeave={() => {
                    setShowSheet(false);
                  }}
                  onMouseEnter={() => {
                    setSelectedCategory(item.categoryId);
                    setShowSheet(true);
                  }}
                  className="mainCategory hover:text-[#00927c] cursor-pointer hover:border-b-2 h-[70px] px-4 border-[#00927c] flex items-center"
                >
                  {item.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="flex items-center gap-2 sm:gap-3 md:gap-4 lg:gap-6">
          <IconButton onClick={() => navigate("/search-products")}>
            <SearchIcon
              className="text-gray-700"
              sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }}
            />
          </IconButton>

          {user.user ? (
            <Button
              onClick={() => navigate("/account/orders")}
              className="flex items-center gap-2"
            >
              <Avatar
                sx={{
                  width: { xs: 22, sm: 23, md: 24, lg: 25 },
                  height: { xs: 22, sm: 23, md: 24, lg: 25 },
                }}
                src="https://cdn.pixabay.com/photo/2015/04/15/09/28/head-723540_640.jpg"
              />
              <h1 className="font-semibold hidden lg:block">
                {user.user?.fullName?.split(" ")[0]}
              </h1>
            </Button>
          ) : (
            <Button
              variant="contained"
              startIcon={<AccountCircleIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />}
              sx={{
                px: { xs: 1.25, sm: 1.5, md: 2 },
                py: { xs: 0.5, sm: 0.75 },
                fontSize: { xs: 12, sm: 13, md: 14 },
              }}
              onClick={() => navigate("/login")}
            >
              Login
            </Button>
          )}

          <IconButton onClick={() => navigate("/wishlist")}>
            <FavoriteBorder
              sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }}
              className="text-gray-700"
            />
          </IconButton>

          <IconButton onClick={() => navigate("/cart")}>
            <Badge
              badgeContent={cart.cart?.cartItems.length}
              color="primary"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: { xs: 10, md: 11, lg: 12 },
                  minWidth: { xs: 16, md: 18, lg: 20 },
                  height: { xs: 16, md: 18, lg: 20 },
                },
              }}
            >
              <AddShoppingCartIcon
                sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }}
                className="text-gray-700"
              />
            </Badge>
          </IconButton>
        </div>
      </div>

      <Drawer open={open} onClose={toggleDrawer(false)}>
        <DrawerList toggleDrawer={toggleDrawer} />
      </Drawer>

      {showSheet && selectedCategory && (
        <div
          onMouseLeave={() => setShowSheet(false)}
          onMouseEnter={() => setShowSheet(true)}
          className="categorySheet absolute top-[4.41rem] left-20 right-20 z-[1500] bg-white"
        >
          <CategorySheet
            setShowSheet={setShowSheet}
            selectedCategory={selectedCategory}
          />
        </div>
      )}
    </Box>
  );
};

export default Navbar;